import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import './style.css';
import { Header, Container, Image, Grid } from "semantic-ui-react";
import Skills from '../skills';
import Profile from '../../assets/images/profile.png';

function Heading() {

	const [offSetY, setOffSetY] = useState(0);
	const handleScroll = () => setOffSetY(window.pageYOffset);


	useEffect(() => {
		window.addEventListener("scroll", handleScroll);

		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<div className="profile-page">
			<Container className="container-header main" >
				<div className="heading-name" >
					<Header as='h2' textAlign='center'
						className="title-name center aligned header" 
						style={{ transform: `translateY(${offSetY * 0.3}px)` }}>Barbara <br />
						Potiriadis <br />
					</Header>
					
				</div>
				
				<Image className="profile-image" centered circular src={Profile} />
				
				<div className="about">
							<div className="about-me-1">
								I'm a Junior Full Stack Web Developer with a background in Marketing and Market Research, bringing a passion for writing clean code
								to architect creative user-friendly interfaces. I've recently completed an intensive 6 month Coding bootcamp course because I wanted a challenge
								and to upskill, where I found my strengths in front end development and has made me attuned to the latest UX/UI designs. 
								<br /><br />
								I'm someone who thrives on continuous learning and experimentation. Since I was young, I've always been curious and experimental by nature with strengths in creativity and problem
								solving. This has helped me to succeed in the course where I am eager to build dynamic front and back-end applications that could complement and add value 
								in a commercial context. I'm an adventurous risk taker, whether I'm in the office or outdoors, who's not
								afraid to step outside the boundaries and tackle any challenge with persistance.
								
					</div>
					<br />
							<div className="about-me-2">
								I have demonstrated a solid ability to work under pressure in the field of market research to manage an online community/panel, which involved
								survey scripting, deploying digital marketing strategies, designing email marketing campaigns and using statistical
								methods to analyse data and draw inferences and insights for clients. When I'm not coding, you'll find me cooking, working out, devouring in ice-cream and 
								dog watching at the local park. Travelling is a core passion of mine, where my travel highlights include the US and Europe. 
				
					</div>
				</div>

				<Skills className="technology-container" />
			</Container>
		</div>
	)
}

export default Heading;
